import type { Types as SduiTypes } from '../types';

export default (
  hour: SduiTypes.hour
): void => {

};
